/* eslint-disable camelcase */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import moment from 'moment'

import { Container as Grid, Row, Col } from 'react-bootstrap'
import CustomProgressBar from '../../components/CustomProgressBar'

import { calculateOverallTopicAccuracy } from '../../../client/lib/legacy/legacyEngine'
import { isFromLCRP } from '../../../shared/lib/util'

import {
  LoadableAboutLearningCurve,
  LoadableInsightsTrends
} from '../../components/Loadable'

import LandingPage from '../../../client/containers/LandingPage'
import LCRPLandingPage from '../../../lcrp/containers/StartScreen'

import TargetAndTopicSummary from '../../../shared/components/Instructor/TargetAndTopicSummary'
import TargetScoreSummary from '../../../client/components/Instructor/TargetScoreSummary'
import TopicPerformanceSummary from '../../../client/components/Instructor/TopicPerformanceSummary'
import LCRPTopicPerformanceDetail from '../../../client/components/Instructor/LCRP-TopicPerformanceDetail'
import EditTargetScoreModal from '../../../client/components/Instructor/EditTargetScoreModal'
import EditTopicsModal from '../../../client/components/Instructor/EditTopicsModal'
import TargetScoreWarningModal from '../../../client/components/Instructor/TargetScoreWarningModal'
import StudentList from '../../../client/components/Instructor/StudentList'
import LCRPStudentList from '../../../client/components/Instructor/LCRP-StudentList'
import PreviewModalForLcrp from '../../../lcrp/components/Instructor/PreviewModalForLcrp'
import StudyPlanItem from '../../../client/components/StudyPlanItem'
import TopBar from '../../../client/components/TopBar'
import FooterBar from '../../../client/components/FooterBar'
import StudentDetail from '../../../client/components/Instructor/StudentDetail/studentDetail.js'
import ArgaErrorBar from '../../../client/containers/ArgaErrorBar/argaErrorBar.js'
import Clickable from '../../../client/components/Clickable'
import TextTruncate from '../../../shared/components/TextTruncate'
import CloseX from '../../../shared/components/CloseX'
import MobileNavDropdown from '../../../shared/components/MobileNavDropdown'
import MobileFilterDropdown from '../../../shared/components/MobileFilterDropdown'

import LCSplitPane, { isVitalSourceURL } from '../../../client/components/LCSplitPane'
import EbookSplitMobile from '../../../client/components/EbookSplitMobile'
import EbookModal from '../../../client/components/EbookModal'

import { actionCreators } from '../../../lcrp/actions'
import { creators } from '../../../client/actions'
import actionProptypes from '../../../client/actions/proptypes'

import uploadIcon from 'Assets/upload.svg'
import syncIcon from 'Assets/sync-icon.svg'
import searchIcon from 'Assets/search-icon-dark-gray.svg'
import clearIcon from 'Assets/x-icon-dark-gray.svg'
import closeIcon from 'Assets/x-icon-gray.svg'
import redDot from 'Assets/redDot.png'
import yellowDot from 'Assets/yellowDot.png'
import greenDot from 'Assets/greenDot.png'

import baseStyle from 'Styles/base.css'
import panelStyle from 'Styles/panel.css'
import progressBarStyle from 'Styles/progress-bar.css'
import iconStyle from 'Styles/icon.css'
import style from './style.css'
import ModalReSyncGrades from '../../components/ModalReSyncGrades'
import HowIsCalculatedModal from '../../../client/components/Instructor/HowIsCalculatedModal'

import params from '../../../client/lib/params'
const {
  forceClassicPreview,
  autoStartTrends,
  returnUrl,
  user_id,
  courseId,
  itemId,
  isRestrictedInstructor,
  previewMode
} = params(window.location.href)

class InstructorPage extends Component {
  constructor (props) {
    super(props)

    this.onEditTargetScoreClick = this.onEditTargetScoreClick.bind(this)
    this.onSetTargetScore = this.onSetTargetScore.bind(this)
    this.onCancelEditTargetScore = this.onCancelEditTargetScore.bind(this)
    this.onEditTopicsClick = this.onEditTopicsClick.bind(this)
    this.onSaveTopicChanges = this.onSaveTopicChanges.bind(this)
    this.onCancelEditTopics = this.onCancelEditTopics.bind(this)
    this.onFilterStudentList = this.onFilterStudentList.bind(this)
    this.onSelectStudent = this.onSelectStudent.bind(this)
    this.onTargetScoreWarningClick = this.onTargetScoreWarningClick.bind(this)
    this.onCancelTargetScoreWarning = this.onCancelTargetScoreWarning.bind(this)
    this.onAboutLearningCurveClick = this.onAboutLearningCurveClick.bind(this)
    this.onInsightsClick = this.onInsightsClick.bind(this)
    this.onPreviewClick = this.onPreviewClick.bind(this)
    this.onBackFromStudentDetail = this.onBackFromStudentDetail.bind(this)
    this.onActivityCompleteRosterButtonClick = this.onActivityCompleteRosterButtonClick.bind(this)
    this.onTopicPerformanceDetailButtonClick = this.onTopicPerformanceDetailButtonClick.bind(this)
    this.onClearSearchInput = this.onClearSearchInput.bind(this)
    this.updateSelectedCategory = this.updateSelectedCategory.bind(this)
    this.onExportStudentRoster = this.onExportStudentRoster.bind(this)
    this.onSyncStudentRoster = this.onSyncStudentRoster.bind(this)
    this.onHowIsCalculatedClick = this.onHowIsCalculatedClick.bind(this)
    this.onCloseHowIsCalculatedModal = this.onCloseHowIsCalculatedModal.bind(this)

    this.state = {
      isEditTargetScoreActive: false,
      isEditTopicsActive: false,
      isHowIsCalculatedActive: false,
      howIsCalculatedWhat: '',
      isTargetScoreWarningActive: false,
      studentFilter: '',
      selectedStudent: null,
      selectedCategory: 'completion',
      scorePromptShown: false,
      showAboutPage: false,
      showInsightsPage: autoStartTrends === true,
      showLcrpPreviewModal: previewMode === 'true' && isFromLCRP() === true && !forceClassicPreview,
      startPreview: previewMode === 'true' && isFromLCRP() === false,
      activityRosterVisible: false,
      topicPerformanceDetailVisible: false,
      splitLeftFooterWidth: '50%',
      modalSuccessResync: false,
      isAdmin: false
    }

    this.categories = {
      completion: 'Completion',
      results: 'Results',
      retakes: 'Retakes'
    }
  }

  componentWillMount () {
    this.props.actions.loadPreload().then(() => {
      this.props.actions.loadActivity(this.props.activityFile).then(() => {
        // If launching directly into Trends and Insights from Courseware
        if (autoStartTrends) {
          const data = { userId: user_id, eventType: 1, courseId, itemId, action: 'Open' }
          this.props.actions.logViewTrendsInsights(data)
        }
      })
    })
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.scoreTarget !== this.props.scoreTarget && nextProps.activity) {
      const check = nextProps.scoreTarget / nextProps.activity.topics.length
      check !== 150 && this.setState({ scorePromptShown: false })
    }
    if (
      !this.props.initialUserData &&
      nextProps.initialUserData &&
      nextProps.initialUserData !== this.props.initialUserData
    ) {
      this.setState({ isAdmin: nextProps.initialUserData.isAdmin })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    /* If coming from the mobile view of a selected student, scroll back to that student in the list and account for
    * header space
    */
    if (this.state.selectedStudent == null &&
      prevState.selectedStudent !== null &&
      this.props.browser.lessThan.medium) {
      setTimeout(() => {
        // next frame, attempt to scroll student into view if it exists
        const studentElement = document.querySelector('#student' + prevState.selectedStudent.index)
        if (studentElement) {
          studentElement.scrollIntoView()
        }
        window.scrollBy(0, -50)
      }, 0)
    }
  }

  setDocumentTitle () {
    if (this.props.activity) {
      const {
        lcrp,
        activityTitle
      } = this.props.activity
      const lcTitle = lcrp ? 'LearningCurve Read & Practice' : 'LearningCurve'

      if (activityTitle && !this.state.showAboutPage) {
        document.title = `${lcTitle}: Instructor Dashboard for ${activityTitle}`
      } else if (this.state.showAboutPage) {
        document.title = `About ${lcTitle}`
      }
    }
  }

  onAboutLearningCurveClick () {
    this.setState({
      showAboutPage: !this.state.showAboutPage,
      isTargetScoreWarningActive: false
    })

    this.props.actions.aboutLearningCurve()
  }

  onInsightsClick () {
    if (!this.state.showInsightsPage) {
      this.props.actions.instructorInsightsTrends()
    }
    if (autoStartTrends) {
      const data = { userId: user_id, eventType: 2, courseId, itemId, action: 'Close' }
      this.props.actions.logViewTrendsInsights(data)
      window.location = decodeURIComponent(returnUrl)
    } else {
      this.setState({
        showInsightsPage: !this.state.showInsightsPage,
        isTargetScoreWarningActive: false
      })
    }
  }

  onFilterStudentList (event) {
    this.setState({ studentFilter: event.target.value })
  }

  onSelectStudent (student) {
    if (student && isFromLCRP()) {
      this.props.actions.logSelectedStudent(student)
    }
    this.setState({ selectedStudent: student })
  }

  onBackFromStudentDetail () {
    this.setState({ selectedStudent: null })
    this.setState({ studentFilter: '' })
  }

  // Target Score handlers
  onEditTargetScoreClick () {
    this.setState({ isEditTargetScoreActive: true })
  }

  onSetTargetScore (targetScore) {
    this.props.actions.setTargetScore(targetScore)
    this.setState({ isEditTargetScoreActive: false })
  }

  onCancelEditTargetScore () {
    this.setState({ isEditTargetScoreActive: false })
  }

  // Target Warning Prompt handlers
  onTargetScoreWarningClick () {
    this.setState({
      isEditTargetScoreActive: true,
      isTargetScoreWarningActive: false,
      scorePromptShown: true
    })
  }

  onCancelTargetScoreWarning () {
    this.setState({
      isTargetScoreWarningActive: false,
      scorePromptShown: true
    })
  }

  // Topic Edit handlers
  onEditTopicsClick () {
    this.setState({ isEditTopicsActive: true })
  }

  onSaveTopicChanges (enabledTopics) {
    this.props.actions.setEnabledTopics(enabledTopics)
    const state = {
      isEditTopicsActive: false
    }
    if (!this.state.scorePromptShown) {
      state.isTargetScoreWarningActive = true
    }
    this.setState(state)
  }

  onCancelEditTopics () {
    this.setState({ isEditTopicsActive: false })
  }

  onHowIsCalculatedClick (type) {
    this.setState({ isHowIsCalculatedActive: true, howIsCalculatedWhat: type })
  }

  onCloseHowIsCalculatedModal () {
    this.setState({ isHowIsCalculatedActive: false })
  }

  onPreviewClick () {
    this.onCloseEbook()
    if (isFromLCRP() === true && !forceClassicPreview) {
      this.setState({ showLcrpPreviewModal: !this.state.showLcrpPreviewModal })
    } else {
      this.setState({ startPreview: !this.state.startPreview })
    }
  }

  onActivityCompleteRosterButtonClick () {
    this.setState({ activityRosterVisible: !this.state.activityRosterVisible })
  }

  onTopicPerformanceDetailButtonClick () {
    this.setState({ topicPerformanceDetailVisible: !this.state.topicPerformanceDetailVisible })
  }

  onClearSearchInput () {
    if (this.state.studentFilter !== '') {
      this.setState({ studentFilter: '' })
      this.refs.studentSearchInput.focus()
    }
  }

  updateSelectedCategory (category) {
    this.setState({
      selectedCategory: category
    })
  }

  renderTopics () {
    return this.props.activity.allTopics.map((topic) => {
      const isActive = _.some(this.props.activity.topics, (activeTopic) => {
        return topic.label === activeTopic.label
      })

      let totalPointsAvailable = topic.class_points_available * 1
      let totalPointsEarned = topic.class_points_earned * 1

      if (this.state.selectedStudent) {
        totalPointsAvailable = topic.pa_arr[this.state.selectedStudent.index] * 1
        totalPointsEarned = topic.pe_arr[this.state.selectedStudent.index] * 1
      }

      if (!isFromLCRP() && !this.state.selectedStudent) {
        totalPointsAvailable = topic.pa_arr.reduce((acc, num) => acc + num, 0)
        totalPointsEarned = topic.pe_arr.reduce((acc, num) => acc + num, 0)
      }

      totalPointsAvailable = isFinite(totalPointsAvailable) && totalPointsAvailable > 0
        ? totalPointsAvailable
        : 0

      totalPointsEarned = isFinite(totalPointsEarned) && totalPointsEarned > 0
        ? totalPointsEarned
        : 0

      const hasQuestions = topic.totalQuestions > 0

      return (
        <StudyPlanItem
          itemClick={this.onToggleEbook.bind(this)}
          key={topic.label}
          label={topic.label}
          totalPointsAvailable={totalPointsAvailable}
          totalPointsEarned={totalPointsEarned}
          hasQuestions={hasQuestions}
          studyPlan={topic.studyPlan}
          disableLinks={this.props.activity.config.disableLinks}
          startedStudents={this.props.activity.studentData.started_students}
          isActive={isActive}
        />
      )
    })
  }

  renderTargetScoreWarningModal () {
    return (
      <TargetScoreWarningModal
        onTargetScoreWarningClick={this.onTargetScoreWarningClick}
        onCancelTargetScoreWarning={this.onCancelTargetScoreWarning}
        onFaqClick={this.onAboutLearningCurveClick}
      />
    )
  }

  renderEditTargetScoreModal () {
    const scoreTarget = this.props.activity ? this.props.activity.score.scoreTarget : null
    const studentActivity = !_.isEmpty(_.filter(this.props.students, 'score'))
    const isSampleResults = this.props.activity.isSampleData != null
    return (
      <EditTargetScoreModal
        scoreTarget={scoreTarget}
        onSetTargetScore={this.onSetTargetScore}
        onCancelEditTargetScore={this.onCancelEditTargetScore}
        studentActivity={studentActivity}
        numberOfTopics={this.props.activity.topics.length}
        hideWarningForSampleStudents={isSampleResults}
      />
    )
  }

  renderEditTopicsModal () {
    const scoreTarget = this.props.activity ? this.props.activity.score.scoreTarget : null
    const studentActivity = !_.isEmpty(_.filter(this.props.students, 'score'))
    const isSampleResults = this.props.activity.isSampleData != null
    return (
      <EditTopicsModal
        scoreTarget={scoreTarget}
        allTopics={this.props.activity.allTopics}
        enabledTopics={this.props.activity.topics}
        questions={this.props.activity.questions}
        onSaveChanges={this.onSaveTopicChanges}
        onCancelEditTopics={this.onCancelEditTopics}
        studentActivity={studentActivity}
        hideWarningForSampleStudents={isSampleResults}
      />
    )
  }

  renderHowIsCalculatedModal (type) {
    return (
      <HowIsCalculatedModal
        type={type}
        onClose={this.onCloseHowIsCalculatedModal}
      />
    )
  }

  renderSampleResultsButton () {
    const isSampleResults = this.props.activity.isSampleData != null

    // if there are students available, and it's not from simulated data, then don't show the sample button
    if (this.props.students.length > 0 && !isSampleResults) {
      return null
    }

    const verbText = isSampleResults ? 'Hide' : 'Show'
    // let actionFunction = isSampleResults ? this.props.actions.hideSampleResults : this.props.actions.viewSampleResults
    let actionFunction
    if (isSampleResults) {
      actionFunction = this.props.actions.hideSampleResults
    } else if (isFromLCRP()) {
      actionFunction = this.props.actions.viewSampleLCRPResults
    } else {
      actionFunction = this.props.actions.viewSampleResults
    }
    const onClick = () => {
      this.onSelectStudent(null)
      actionFunction()
    }

    return (
      <button
        data-test-id="toggleSampleStudents"
        onClick={onClick}
        className={classnames('btn-cdl-secondary', style.sampleButton)}
      >
        {verbText} Sample Students
      </button>
    )
  }

  renderMobileFilter () {
    const { width } = this.props.browser
    const isMobile = width < 769

    if (isMobile) {
      return (
        <MobileFilterDropdown
          updateSelectedCategory={this.updateSelectedCategory}
          categories={this.categories}
          selectedCategory={this.state.selectedCategory}
        />
      )
    }
  }

  onSyncStudentRoster () {
    const { activity: { config: { courseId, itemId } } } = this.props
    const bodyData = new FormData()
    bodyData.append('assignmentId', itemId)
    bodyData.append('courseId', courseId)
    bodyData.append('type', 'cron-re-sync')
    this.setState({ modalSuccessResync: true })
    fetch('/api/v1/grade_sync.php', {
      credentials: 'same-origin',
      method: 'post',
      body: bodyData,
      headers: {
        Accept: 'application/json'
      }
    }).catch((error) => {
      alert(error.message)
      // Error
    })
  }

  onExportStudentRoster () {
    const { activity: { activityTitle, students } } = this.props

    // solutions from below - note: we don't support IE
    // https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
    const csvData = [
      ['activity_title', 'email', 'first_name', 'last_name',
      'score', 'target', 'grade', 'completion_localtime'].join(','),
      ...students.map(student => {
        return [
          `"${activityTitle}"`, // activity_title
          `"${student.id}"`, // email
          `"${student.firstName}"`, // first_name
          `"${student.lastName}"`, // last_name
          student.score, // score
          student.activity_state.target, // target
          student.grade || '0', // grade
          student.completedTimestamp !== null? `"${moment.utc(student.completedTimestamp).local().format('ddd, MMM D, h:mma')}"` : '' // completion_localtime
        ].join(',')
      })
    ].join('\n')

    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `lc_activity-completion-roster_${_.kebabCase(activityTitle)}.csv`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  renderStudentListView () {
    const { isAdmin } = this.state
    const { width } = this.props.browser
    const isMobile = width < 769

    return (
      <div tabIndex="0">
        <div
          className={classnames(panelStyle.large, style.rosterContainer)}
        >
          {
            this.props.browser.lessThan.medium
              ? <input
                type="image"
                aria-label="Hide Activity Completion Roster"
                className={style.hideStudents}
                data-test-id="hideCompletionRosterBtn"
                src={closeIcon}
                onClick={this.onActivityCompleteRosterButtonClick}
                tabIndex="0"
              />
              : null}
          <span className={style.rosterHeaderContainer}>
            <h2
              className={style.rosterHeader}
            >
              Activity Completion Roster
            </h2>
            <div className={style.btnContainer}>
              <button
                className={classnames('btn-cdl-secondary', style.exportButton)}
                data-test-id="exportStudentRosterBtn"
                onClick={this.onExportStudentRoster}
              >
                <span className={classnames('sr-only')}>
                  Export Activity Completion Roster
                </span>
                <span aria-hidden={true} className={style.exportButtonContent}>
                  <img src={uploadIcon} className={style.exportIcon} />
                  Export
                </span>
              </button>
              {isAdmin && (
                <button
                  className={classnames('btn-cdl-secondary', style.syncButton)}
                  data-test-id="syncStudentRosterBtn"
                  onClick={this.onSyncStudentRoster}
                >
                  <span className={classnames('sr-only')}>
                  Re-sync grades.  This may be needed if a due date changes or for new due date exceptions.
                  </span>
                  <span aria-hidden={true} className={style.exportButtonContent}>
                    <img src={syncIcon} className={style.exportIcon} />
                    Sync Grades
                  </span>
                </button>
              )}
            </div>
          </span>
          <div className={classnames('input-group', style.searchInputGroup)}>
            <input
              ref="studentSearchInput"
              className={classnames('form-control', style.searchInput)}
              placeholder="Search Students"
              aria-label="Search for students"
              onChange={this.onFilterStudentList}
              value={this.state.studentFilter}
              tabIndex="0"
              data-test-id="studentSearchInput"
            />
            
            <button
              className={classnames('btn', 'btn-outline-secondary', style.searchIconContainer)}
              onClick={this.onClearSearchInput}
              alt={this.state.studentFilter ? 'Clear Student Search Criteria' : 'Search Student'}
            >
              <input
                type="image"
                className={style.searchIcon}
                data-test-id="studentListSearchIcon"
                tabIndex="0"
                src={this.state.studentFilter ? clearIcon : searchIcon}
              />
            </button>
          </div>
          {this.renderMobileFilter()}
        </div>
        {isFromLCRP()
          ? <LCRPStudentList
            browser={this.props.browser}
            students={this.props.students}
            studentFilter={this.state.studentFilter}
            scoreTarget={this.props.scoreTarget}
            onStudentSelected={this.onSelectStudent}
            selectedStudent={this.state.selectedStudent}
            selectedCategory={this.state.selectedCategory}
            isMobile={isMobile}
          />
          : <StudentList
            students={this.props.students}
            studentFilter={this.state.studentFilter}
            scoreTarget={this.props.scoreTarget}
            onStudentSelected={this.onSelectStudent}
            selectedStudent={this.state.selectedStudent}
            splitPane={this.props.uiState.isLegacyEbookDisplayed}
          />
        }
        <div className={panelStyle.base}>
          {this.renderSampleResultsButton()}
        </div>
        {this.state.modalSuccessResync && (
          <ModalReSyncGrades onClose={() => this.setState({ modalSuccessResync: false })} />
        )}
      </div>
    )
  }

  renderTopicPerformanceDetail () {
    const { tmpSampleData } = this.props.activity
    let completedTimestamp
    if (isFromLCRP()) {
      completedTimestamp = this.props.activity.completedTimestamp
    } else {
      completedTimestamp = this.state.selectedStudent && this.state.selectedStudent.completedTimestamp
        ? this.state.selectedStudent.completedTimestamp
        : null
    }

    const topics = tmpSampleData ? tmpSampleData.topics : this.props.activity.topics
    const classAverage = calculateOverallTopicAccuracy(topics, -1)
    let percentage = 0

    if (percentage === 0 && !isFromLCRP()) {
      if (this.state.selectedStudent) {
        const studentIndex = parseInt(this.state.selectedStudent.index, 10)
        percentage = calculateOverallTopicAccuracy(topics, studentIndex)
      } else {
        percentage = classAverage
      }
    } else if (isFromLCRP() && percentage === 0) {
      percentage = classAverage
    }

    if (isFromLCRP()) {
      return (
        <LCRPTopicPerformanceDetail
          browser={this.props.browser}
          onTopicButtonClick={this.onTopicPerformanceDetailButtonClick}
          activity={{ ...this.props.activity, ...tmpSampleData } || this.props.activity}
          selectedStudent={this.state.selectedStudent}
          setSelectedStudent={this.onSelectStudent}
          classAverage={classAverage}
          updateRadioButtons={this.props.actions.updateRadioButtons}
          originalScoreSelected={this.props.uiState.radioButtons.originalScoreSelected}
          classScoreSelected={this.props.uiState.radioButtons.classScoreSelected}
          itemClick={this.onToggleEbook.bind(this)}
          accuracyAverage={percentage}
        />
      )
    }

    const timeOnTask = this.state.selectedStudent && this.state.selectedStudent.timeOnTask
      ? Number(this.state.selectedStudent.timeOnTask)
      : undefined

    let totalQuestionsReceived = 0
    if (this.state.selectedStudent && this.state.selectedStudent.score > 0) {
      this.state.selectedStudent.activity_state.tp.forEach(({ qr }) => {
        totalQuestionsReceived += qr
      })
    }
    const startedTimestamp = this.state.selectedStudent ? this.state.selectedStudent.startedTimestamp : undefined
    const totalQuizTimeInMs = this.state.selectedStudent && timeOnTask ? timeOnTask * 1000 : undefined
    const avgAnswerSpeed = this.state.selectedStudent ? msToTime(totalQuizTimeInMs / totalQuestionsReceived) : undefined
    const totalQuizTime = this.state.selectedStudent ? msToTime(totalQuizTimeInMs) : undefined
    const hintCount = this.state.selectedStudent ? this.state.selectedStudent.activity_state.hintCount : undefined
    const questionSkipCount = this.state.selectedStudent && (this.state.selectedStudent.activity_state.qr > this.state.selectedStudent.activity_state.completedQuestionCount) ? this.state.selectedStudent.activity_state.qr - this.state.selectedStudent.activity_state.completedQuestionCount : undefined

    return (
      <div className={style.splitOverrideBottomPadding}>
        <div>
          <div className={this.state.selectedStudent ? style.studyPlanHeaderContainer : panelStyle.base}>
            {this.state.selectedStudent &&
            <Clickable
              data-test-id="closeStudentDetailBtn"
              onClick={(event) => this.onSelectStudent(null)}
              className={classnames(style.closeXClick, style.closeStudentDetails)}
            >
              <input
                type="image"
                alt={'Close student detail'}
                src={closeIcon}
                className={baseStyle.svgIcon}
              />
            </Clickable>}
            {this.props.browser.lessThan.medium
              ? <input
                type="image"
                aria-label="Hide Topic Performance Details"
                className={classnames(style.hideStudents, style.hideStudentsTopics)}
                data-test-id="hideTopicPerformanceDetailsBtn"
                src={closeIcon}
                onClick={this.onTopicPerformanceDetailButtonClick}
                tabIndex="0"
              />
              : null}
            <h2 className={style.studyPlanHeader} data-test-id="activityPerformanceLabel">
              Activity Performance: <span className={style.studyPlanTitle}>{this.state.selectedStudent ? this.state.selectedStudent.name : 'All Students'}</span>
            </h2>
            <Row style={{ display: 'flex', alignItems: 'center' }}>
              <Col xs={8} sm={8} md={8} lg={10}>
                <p className={style.progressAccuracyLabel}>Average Accuracy:</p>
                <CustomProgressBar
                  dataTestId="averageAccuracyBar"
                  className={classnames('progress', progressBarStyle.base, style.progressBar)}
                  bsClass={classnames('progress-bar', style.progressBarValue)}
                  ariaLabel={`You have ${percentage} points.`}
                  now={percentage}
                  min={0}
                  max={100}
                />
              </Col>
              <Col xs={4} sm={4} md={4} lg={2} className={style.accuracyCol}>
                <p className={style.accuracyLabelScore}>Accuracy</p>
                <span
                  className={style.accuracyValue}
                  data-test-id="topicPerformanceAccuracy"
                >{this.renderGradedDot(percentage)}</span>
              </Col>
            </Row>
            {!this.state.selectedStudent &&
            <>
              <p className={style.topicAccuracyLabelScore}>Accuracy</p>
              <h2 className={style.studyPlanHeaderSub}>
                Topic Performance
              </h2>
            </>}
          </div>
          {this.state.selectedStudent &&
          <div className={this.state.selectedStudent ? panelStyle.base : null}>
            <Row className={style.studentStats} style={{ textAlign: 'left' }}>
              {
                startedTimestamp &&
                <Col className={style.studentStatsItem} sm={12}>
                  <span className={style.studentStatsLabel}>Activity Started: </span>
                  <span
                    className={style.studentStatsValue}
                    data-test-id="topicAndPerformanceQuizStartedTimestamp"
                  > <strong>{moment.utc(startedTimestamp).local().format('ddd, MMM D, h:mma')}</strong>
                  </span>
                </Col>
              }
              {
                timeOnTask &&
                <Col className={style.studentStatsItem} sm={12}>
                  <span className={style.studentStatsLabel}>Time Spent: </span>
                  <span
                    className={style.studentStatsValue}
                    data-test-id="topicAndPerformanceQuizTimeOnTask"
                  > <strong>{totalQuizTime}</strong>
                  </span>
                </Col>
              }
              {
                avgAnswerSpeed &&
                <Col className={style.studentStatsItem} sm={12}>
                  <span className={style.studentStatsLabel}>Average Answer Speed: </span>
                  <span
                    className={style.studentStatsValue}
                    data-test-id="topicAndPerformanceQuizAverageAnswerSpeed"
                  > <strong>{avgAnswerSpeed}/question</strong>
                  </span>
                </Col>
              }
              {
                hintCount >= 0 &&
                <Col className={style.studentStatsItem} sm={12}>
                  <span className={style.studentStatsLabel}>Hints Taken: </span>
                  <span
                    className={style.studentStatsValue}
                    data-test-id="topicAndPerformanceQuizHintsTaken"
                  > <strong>{hintCount}</strong>
                  </span>
                </Col>
              }
              {
                questionSkipCount >= 0 &&
                <Col className={style.studentStatsItem} sm={12}>
                  <span className={style.studentStatsLabel}>Questions Skipped: </span>
                  <span
                    className={style.studentStatsValue}
                    data-test-id="topicAndPerformanceQuizQuestionsSkipped"
                  > <strong>{questionSkipCount}</strong>
                  </span>
                </Col>
              }
              {
                completedTimestamp &&
                <Col className={style.studentStatsItem} sm={12}>
                  <span className={style.studentStatsLabel}>Target Score Reached: </span>
                  <span
                    className={style.studentStatsValue}
                    data-test-id="topicAndPerformanceQuizCompletedTimestamp"
                  > <strong>{moment.utc(completedTimestamp).local().format('ddd, MMM D, h:mma')}</strong>
                  </span>
                </Col>
              }
            </Row>
            <p className={style.selectedTopicAccuracyLabelScore}>Accuracy</p>
            <h2 className={style.studyPlanHeaderSub}>
              Topic Performance
            </h2>
          </div>}
        </div>
        {this.renderTopics()}
      </div>
    )
  }

  renderGradedDot (score) {
    if (score === 0 || isNaN(score)) {
      return '-- %'
    }
    let gradedDot = greenDot
    if (score < 70) {
      gradedDot = redDot
    } else if (score < 90) {
      gradedDot = yellowDot
    }
    return ([
      <img
        key={score}
        src={gradedDot}
        className={classnames(iconStyle.small, style.gradedDotImg)}
        alt={'graded dot'}
        tabIndex="-1"
      />,
      `${score}%`
    ])
  }

  renderInsightsBtn () {
    const { headerStyle } = this.props.activity.config
    const isAchieve = headerStyle === 'achieve'
    return (
      <Clickable
        onMouseHover={() => LoadableInsightsTrends.preload()}
        onClick={this.onInsightsClick}
        tabIndex="0"
      >
        <span
          data-test-id="openInstructorInsights"
          className={classnames(style.aboutInsightsBtn, baseStyle['hidden-md-down'], {
            [style.aboutLearningCurve]: !isAchieve,
            [style.achieveAboutLearningCurve]: isAchieve
          })}
        >
         Trends & Insights
        </span>
      </Clickable>
    )
  }

  onCloseEbook () {
    this.props.actions.closeSplitScreenEbookModal()
    this.setState({
      splitPane: false,
      EbookPspItem: false
    })

    this.props.uiState.isSplitScreenEbookDisplayed = false
    this.props.uiState.isLegacyEbookDisplayed = false
  }

  onToggleEbook (item) {
    const processOpen = item.displayValue !== undefined
    this.onCloseEbook()

    if (processOpen === true) {
      if (isVitalSourceURL(item.pageId) === true) {
        this.setState({
          splitPane: true,
          EbookPspItem: item
        })

        this.props.uiState.isSplitScreenEbookDisplayed = true
        this.props.uiState.isLegacyEbookDisplayed = false
      }
      this.props.actions.showPspEbook(item)
    }
  }

  onResizeSplit (newWidth) {
    this.setState({
      splitLeftFooterWidth: newWidth
    })
  }

  renderSplitPane () {
    return (
      <LCSplitPane
        isLegacyEbook={this.props.uiState.isLegacyEbookDisplayed}
        isInstructor={true}
        browser={this.props.browser}
        toggle={this.onToggleEbook.bind(this)}
        PSPItem={this.state.EbookPspItem}
        outerFooterCalc={this.onResizeSplit.bind(this)}
        lastWidth={this.state.splitLeftFooterWidth}
      >
        {this.renderDefaultPage()}
      </LCSplitPane>
    )
  }

  renderDefaultPage () {
    const selectedStudentIndex = this.state.selectedStudent ? this.state.selectedStudent.index : -1
    const { topics } = this.props.activity.tmpSampleData ? this.props.activity.tmpSampleData : this.props.activity
    const overallQuestionAccuracy = calculateOverallTopicAccuracy(topics, isFromLCRP() ? -1 : selectedStudentIndex)

    const splitOverride = this.state.splitPane ? style.splitOverride : ''
    const splitPanelOverride = this.state.splitPane ? style.splitPanelOverride : ''
    let totalStudents, startedStudents, completedStudents

    if (this.props.activity.tmpSampleData) {
      totalStudents = this.props.activity.tmpSampleData.studentData.user_id_array.length
      startedStudents = this.props.activity.tmpSampleData.studentData.started_students
      completedStudents = this.props.activity.tmpSampleData.studentData.completed_students
    } else {
      completedStudents = this.props.activity.studentData.completed_students
      startedStudents = this.props.activity.studentData.started_students
      totalStudents = this.props.activity.studentData.user_id_array
        ? this.props.activity.studentData.user_id_array.length
        : 0
    }

    return (
      <div>
        {this.props.uiState.showArgaError ? <ArgaErrorBar className={style.instructorBump} /> : null}
        <Grid className={classnames(style.innerContent, splitOverride)}>
          {this.state.isEditTargetScoreActive ? this.renderEditTargetScoreModal() : null}
          {this.state.isEditTopicsActive ? this.renderEditTopicsModal() : null}
          {this.state.isTargetScoreWarningActive && !this.state.scorePromptShown
            ? this.renderTargetScoreWarningModal()
            : null}
          <Row>
            <Col
              sm={(this.props.browser.lessThan.medium || this.state.splitPane) ? 12 : 6}
              tabIndex="0"
              className={splitPanelOverride}
            >
              <TargetScoreSummary
                scoreTarget={this.props.scoreTarget}
                onEditTargetScoreClick={this.onEditTargetScoreClick}
                totalStudents={totalStudents}
                startedStudents={startedStudents}
                completedStudents={completedStudents}
                individualStudentSelected={this.state.selectedStudent != null}
                browser={this.props.browser}
                isRestrictedInstructor={this.props.isRestrictedInstructor}
              />
            </Col>
            {this.props.browser.lessThan.medium
              ? <Col
                sm={(this.props.browser.lessThan.medium || this.state.splitPane) ? 12 : 6}
                className={splitPanelOverride}
              >
                {!this.state.activityRosterVisible && this.props.browser.lessThan.medium
                  ? <button
                    data-test-id="activityRosterBtn"
                    className={classnames('btn-cdl-main', style.showStudents)}
                    onClick={this.onActivityCompleteRosterButtonClick}
                    tabIndex="0"
                  >
                    Show activity completion roster
                  </button>
                  : null}
                {this.state.activityRosterVisible && this.props.browser.lessThan.medium
                  ? this.renderStudentListView()
                  : null}
              </Col>
              : null}
            <Col
              sm={(this.props.browser.lessThan.medium || this.state.splitPane) ? 12 : 6}
              className={classnames(splitPanelOverride, style.rightContent)} tabIndex="0"
            >
              <TopicPerformanceSummary
                topicCount={this.props.activity.topics.length}
                onEditTopicsClick={this.onEditTopicsClick}
                questionAccuracy={overallQuestionAccuracy}
                startedStudents={startedStudents}
                individualStudentSelected={this.state.selectedStudent != null}
                selectedStudent={this.state.selectedStudent}
                showEditTopicsButton={true}
                onShowAllStudents={() => this.onSelectStudent(null)}
                browser={this.props.browser}
                isRestrictedInstructor={this.props.isRestrictedInstructor}
              />
            </Col>
            {/* TODO: Replace clearfix with something else */}
            {/* <Clearfix /> */}
            <Col
              sm={(this.props.browser.lessThan.medium || this.state.splitPane) ? 12 : 6}
              className={classnames(splitPanelOverride)}
            >
              {!this.props.browser.lessThan.medium ? this.renderStudentListView() : null}
            </Col>
            <Col
              sm={(this.props.browser.lessThan.medium || this.state.splitPane) ? 12 : 6}
              className={classnames(splitPanelOverride, style.rightContent)}
              tabIndex="0"
            >
              {!this.state.topicPerformanceDetailVisible && this.props.browser.lessThan.medium
                ? <button
                  data-test-id="topicPerformanceDetailBtn"
                  className={classnames('btn-cdl-main', style.showStudents)}
                  onClick={this.onTopicPerformanceDetailButtonClick}
                  tabIndex="0"
                >
                  Show topic performance details
                </button>
                : null}
              {this.state.topicPerformanceDetailVisible || !this.props.browser.lessThan.medium
                ? this.renderTopicPerformanceDetail()
                : null}
            </Col>
          </Row>
        </Grid>
        {this.props.browser.lessThan.medium
          ? <FooterBar className={baseStyle.instructorFooter}>
            <Row>
              <Col sm={12}>
                <Row tabIndex="0">
                  <Col xs={6}>
                    <button
                      className={classnames('btn-cdl-secondary', style.footerButton)}
                      onClick={this.onAboutLearningCurveClick}
                      tabIndex="0"
                      data-test-id="instructorAboutLC"
                      onMouseHover={() => LoadableAboutLearningCurve.preload()}
                    >
                    About<span className={baseStyle['hidden-md-down']}> LearningCurve</span>
                    </button>
                  </Col>
                  <Col xs={6}>
                    <button
                      className={classnames('btn-cdl-secondary', style.footerButton)}
                      onClick={this.onPreviewClick}
                      tabIndex="0"
                      data-test-id="instructorPreviewAsStudent"
                    >
                    Preview<span className={baseStyle['hidden-md-down']}> as student</span>
                    </button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </FooterBar>
          : null}
      </div>
    )
  }

  renderSingleCardView () {
    const selectedStudentIndex = this.state.selectedStudent ? this.state.selectedStudent.index : -1
    const { topics } = this.props.activity.tmpSampleData ? this.props.activity.tmpSampleData : this.props.activity
    const overallQuestionAccuracy = calculateOverallTopicAccuracy(topics, isFromLCRP() ? -1 : selectedStudentIndex)
    let totalStudents, startedStudents, completedStudents

    if (this.props.activity.tmpSampleData) {
      totalStudents = this.props.activity.tmpSampleData.studentData.user_id_array.length
      startedStudents = this.props.activity.tmpSampleData.studentData.started_students
      completedStudents = this.props.activity.tmpSampleData.studentData.completed_students
    } else {
      completedStudents = this.props.activity.studentData.completed_students
      startedStudents = this.props.activity.studentData.started_students
      totalStudents = this.props.activity.studentData.user_id_array
        ? this.props.activity.studentData.user_id_array.length
        : 0
    }
    return (
      <Grid className={classnames(style.innerContent)}>
        {this.state.isEditTargetScoreActive ? this.renderEditTargetScoreModal() : null}
        {this.state.isEditTopicsActive ? this.renderEditTopicsModal() : null}
        {this.state.isHowIsCalculatedActive ? this.renderHowIsCalculatedModal(this.state.howIsCalculatedWhat) : null}
        {this.state.isTargetScoreWarningActive && !this.state.scorePromptShown
          ? this.renderTargetScoreWarningModal()
          : null}
        <TargetAndTopicSummary
          scoreTarget={this.props.scoreTarget}
          onEditTargetScoreClick={this.onEditTargetScoreClick}
          totalStudents={totalStudents}
          startedStudents={startedStudents}
          completedStudents={completedStudents}
          individualStudentSelected={this.state.selectedStudent != null}
          browser={this.props.browser}
          topicCount={this.props.activity.topics.length}
          onEditTopicsClick={this.onEditTopicsClick}
          questionAccuracy={overallQuestionAccuracy}
          selectedStudent={this.state.selectedStudent}
          showEditTopicsButton={true}
          showHowIsCalculated={this.onHowIsCalculatedClick}
          onShowAllStudents={() => this.onSelectStudent(null)}
          studentData={this.props.students}
          isFromLCRP={isFromLCRP()}
          isRestrictedInstructor={this.props.isRestrictedInstructor}
          averageTimeToComplete={this.props.activity.courseAvgTime || '--'}
          estimatedTimeToComplete={this.props.activity.courseEstTime || '--'}
          ffEstimatedTimeToCompleteEnabled={this.props.ffEstimatedTimeToCompleteEnabled}
        />
        <Row className={style.activitySection}>
          <Col
            xs={12}
            sm={6}
            className={style.colXs12}
          >
            {this.renderStudentListView()}
          </Col>
          <Col
            xs={12}
            sm={6}
            className={classnames(style.performanceDetailContainer, style.colXs12)}
          >
            {this.renderTopicPerformanceDetail()}
          </Col>
        </Row>
      </Grid>
    )
  }

  renderDesktopNav () {
    const { lessThan } = this.props.browser
    const locationTitle = isFromLCRP() ? 'Read & Practice' : 'LearningCurve'
    const { headerStyle } = this.props.activity.config
    const isAchieve = headerStyle === 'achieve'

    return (
      <Col
        sm={isFromLCRP() ? 8 : 6}
        md={6}
        lg={5}
        className={baseStyle['hidden-md-down']}
        role="navigation"
      >
        <button
          data-test-id="previewAsStudentBtn"
          className={classnames('btn-cdl-main', style.headerButton)}
          onClick={this.onPreviewClick}
          tabIndex="0"
        >
          Preview<span className={baseStyle['hidden-md-down']}> as a Student</span>
        </button>
        <Clickable
          onClick={this.onAboutLearningCurveClick}
          onMouseHover={() => LoadableAboutLearningCurve.preload()}
          tabIndex="0"
        >
          <span
            data-test-id="openInstructorAbout"
            className={classnames({
              [style.aboutLearningCurve]: !isAchieve,
              [style.achieveAboutLearningCurve]: isAchieve
            }, baseStyle['hidden-md-down'])}
          >
           About <span className={baseStyle['hidden-md-down']}> {locationTitle}</span>
          </span>
        </Clickable>
        {isFromLCRP() && this.renderInsightsBtn()}
      </Col>
    )
  }

  renderMobileNav () {
    const locationTitle = isFromLCRP() ? 'Read & Practice' : 'LearningCurve'

    const { headerStyle } = this.props.activity.config
    const cssModifier = headerStyle === 'achieve' ? 'Dark' : 'Lite'

    return (
      <Col xs={6}>
        <MobileNavDropdown
          openInsights={this.onInsightsClick}
          onPreviewClick={this.onPreviewClick}
          onAboutLearningCurveClick={this.onAboutLearningCurveClick}
          locationTitle={locationTitle}
          isInstructor
          cssModifier={cssModifier}
        />
      </Col>
    )
  }

  renderTopBar () {
    const { lessThan } = this.props.browser
    const { width } = this.props.browser
    const isMobile = width < 769
    const { headerStyle } = this.props.activity.config
    const isAchieve = headerStyle === 'achieve'

    return (
      <TopBar headerStyle={headerStyle}>
        <CloseX closeAction={this.props.actions.closeActivity} />
        <Grid className={classnames(baseStyle.topBarWrapper, style.InstructorTopBar, baseStyle.closeXSpace)}>
          <Row className={baseStyle.topBarRow}>
            <Col xs={12} sm={isFromLCRP() ? 4 : 6} md={6} lg={7}>
              {!isAchieve &&
              <h1
                data-test-id="pageTitle"
                className={style.pageTitle}
                tabIndex="0"
                style={{ fontSize: lessThan.medium ? 14 : 18 }}
              >
                <TextTruncate
                  text={this.props.activity.activityTitle}
                  line={2}
                  browser={this.props.browser}
                />
              </h1>}
            </Col>
            {isMobile ? this.renderMobileNav() : this.renderDesktopNav()}
          </Row>
        </Grid>
      </TopBar>
    )
  }

  render () {
    this.setDocumentTitle()

    if (this.props.browser.lessThan.medium && this.props.uiState.isSplitScreenEbookDisplayed &&
      !this.props.activity.score.curCard && !this.state.startPreview) {
      window.scrollTo(0, 0)
      return (
        <EbookSplitMobile
          onClick={this.onToggleEbook.bind(this)}
          PSPItem={this.state.EbookPspItem}
          isPreview={this.state.startPreview}
        />
      )
    }

    if (this.state.showLcrpPreviewModal) {
      return (
        <PreviewModalForLcrp
          onClick={this.onPreviewClick}
          onSelect={this.props.actions.previewMode}
        />
      )
    }
    if (this.props.uiState.showAssignmentReading) {
      return (
        <LCRPLandingPage
          activity={this.props.activity}
          previewMode="true"
          courseDashboardData={this.props.courseDashboardData}
        />
      )
    }

    if (this.state.startPreview) {
      return (
        <LandingPage
          previewMode={true}
          endPreview={this.onPreviewClick}
        />
      )
    }

    if (!this.props.activity || !this.props.activity.topics) {
      return <div data-test-id="loading">Loading...</div>
    }

    const { headerStyle } = this.props.activity.config

    if (this.state.showAboutPage) {
      return (
        <LoadableAboutLearningCurve
          onClick={this.onAboutLearningCurveClick}
          browser={this.props.browser}
          isLcrp={isFromLCRP()}
          headerStyle={headerStyle}
        />
      )
    }

    if (this.state.showInsightsPage) {
      let courseDashboardData = this.props.courseDashboardData
      if (Object.keys(courseDashboardData).length === 0) {
        courseDashboardData = {
          studentDataAllAttempts: [],
          accuracyAverageAllAttempts: 0,
          accuracyDataAllAttempts: [],
          accuracyDataFirstAttempts: [],
          accuracyAverageFirstAttempts: 0,
          averageStudentAccessTime: 0,
          averageStudentQuestionTime: 0,
          accuracyRanges: {
            lowAccuracyPercent: 0,
            mediumAccuracyPercent: 0,
            highAccuracyPercent: 0
          },
          assignmentOverview: []
        }
      }
      return (
        <LoadableInsightsTrends
          onClick={this.onInsightsClick}
          browser={this.props.browser}
          courseDashboardData={courseDashboardData}
          initialUserData={this.props.initialUserData}
          allTopics={this.props.activity.allTopics}
          actions={this.props.actions}
          onSelectStudent={(student) => this.onSelectStudent(student)}
          config={this.props.activity.config}
        />
      )
    }

    // small screen only version of student detail
    // eslint-disable-next-line no-unused-vars
    const classAverage = calculateOverallTopicAccuracy(this.props.activity.topics, -1)
    if (this.state.selectedStudent && this.props.browser.lessThan.medium) {
      if (isFromLCRP()) {
        const { tmpSampleData } = this.props.activity
        const topics = tmpSampleData ? tmpSampleData.topics : this.props.activity.topics
        const classAverage = calculateOverallTopicAccuracy(topics, -1)
        let percentage = 0

        if (percentage === 0 && !isFromLCRP()) {
          percentage = classAverage
        } else if (isFromLCRP() && percentage === 0) {
          percentage = classAverage
        }

        return (
          <LCRPTopicPerformanceDetail
            browser={this.props.browser}
            onTopicButtonClick={this.onTopicPerformanceDetailButtonClick}
            activity={{ ...this.props.activity, ...tmpSampleData } || this.props.activity}
            selectedStudent={this.state.selectedStudent}
            setSelectedStudent={this.onSelectStudent}
            onBackClick={this.onBackFromStudentDetail}
            classAverage={classAverage}
            updateRadioButtons={this.props.actions.updateRadioButtons}
            originalScoreSelected={this.props.uiState.radioButtons.originalScoreSelected}
            classScoreSelected={this.props.uiState.radioButtons.classScoreSelected}
            itemClick={this.onToggleEbook.bind(this)}
            accuracyAverage={percentage}
          />
        )
      }
      return (
        <StudentDetail
          activity={this.props.activity}
          selectedStudent={this.state.selectedStudent}
          scoreTarget={this.props.scoreTarget}
          actions={this.props.actions}
          onBackClick={this.onBackFromStudentDetail}
          browser={this.props.browser}
        />
      )
    }

    const topBarSpaceStyle = this.state.splitPane ? '' : baseStyle.topBarSpace
    const splitMargin = this.state.splitPane ? style.splitMargin : ''

    return (
      <div>
        <div className={classnames(style.container, topBarSpaceStyle, splitMargin)}>
          {this.props.activity.config.headerStyle !== 'hidden' && this.renderTopBar()}
          <div {...(this.props.activity.config.headerStyle !== 'achieve' ? { role: 'main' } : {})}>
            {this.state.splitPane
              ? this.renderSplitPane()
              : this.renderSingleCardView()}
            {this.props.uiState.isEbookModalDisplayed
              ? <EbookModal
                data={this.props.uiState.ebookModalDisplayValue}
                onClick={this.props.actions.closeEbookModal}
              />
              : null
            }
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  let scoreTarget = 0
  let students = []
  const courseDashboardData = state.core.courseDashboardData ? state.core.courseDashboardData : {}

  if (state.core.activity && state.core.activity.tmpSampleData) {
    scoreTarget = state.core.activity.tmpSampleData.score.scoreTarget
    students = state.core.activity.tmpSampleData.students
  } else if (state.core.activity) {
    scoreTarget = state.core.activity.score ? state.core.activity.score.scoreTarget : 0
    students = state.core.activity.students
  }

  return {
    browser: state.browser,
    activity: state.core.activity,
    uiState: state.core.uiState,
    initialUserData: state.core.initialUserData,
    paused: state.paused,
    waiting: state.waiting,
    activityFile: state.routing.locationBeforeTransitions.query.file, // from launchpad
    scoreTarget,
    students,
    courseDashboardData,
    isRestrictedInstructor,
    ffEstimatedTimeToCompleteEnabled: state.core.config && state.core.config.FF_ESTIMATED_TIME_TO_COMPLETE_ENABLED === 'true'
  }
}

InstructorPage.propTypes = {
  browser: PropTypes.object,
  activity: PropTypes.object,
  uiState: PropTypes.object,
  activityFile: PropTypes.string,
  waiting: PropTypes.bool.isRequired,
  students: PropTypes.array,
  scoreTarget: PropTypes.number,
  paused: PropTypes.bool.isRequired,
  courseDashboardData: PropTypes.object,
  actions: actionProptypes,
  initialUserData: PropTypes.object,
  isRestrictedInstructor: PropTypes.bool,
  ffEstimatedTimeToCompleteEnabled: PropTypes.bool
}

function mapDispatchToProps (dispatch, ownProps) {
  Object.assign(actionCreators, creators)
  return { actions: bindActionCreators(actionCreators, dispatch) }
}

export const msToTime = (ms) => {
  const days = Math.floor(ms / (24 * 60 * 60 * 1000))
  const h = ms % (24 * 60 * 60 * 1000)
  const hrs = Math.floor(h / (60 * 60 * 1000))
  const m = h % (60 * 60 * 1000)
  const mins = Math.floor(m / (60 * 1000))
  const s = m % (60 * 1000)
  const secs = Math.floor(s / 1000)
  let messageString = ''
  if (days >= 1) {
    messageString += days + ' days, '
  }
  if (hrs >= 1) {
    messageString += hrs + ' hours, '
  }
  if (mins >= 1) {
    messageString += mins + ' min, '
  }
  if (secs >= 1) {
    messageString += secs + ' sec'
  } else {
    messageString += '-'
  }

  return messageString
}

export default connect(mapStateToProps, mapDispatchToProps)(InstructorPage)
